import React from "react";
import { graphql } from "gatsby";
import { useTranslation } from "gatsby-plugin-react-i18next";

import Layout from "../../components/Layout";
import MetaComponents from "../../components/seo/MetaComponents";
import BreadcrumbList from "../../components/seo/BreadcrumbList";
import Cooperation from "../../components/Cooperation";
import OfferCheck from "../../components/OfferCheck";
import HowDoesItWork from "../../components/HowDoesItWork";
import FantasticNumbersBar from "../../components/FantasticNumbersBar";

const Konditionencheck = () => {
    const { t } = useTranslation();

    return (
        <Layout>
            <MetaComponents title={t("page.meta.title")} description={t("page.meta.description")} />
            <OfferCheck
                defaultTerm={35}
                defaultMortgage={320000}
                defaultUsersOffer={1400}
                hasMarginTop
                useH1
                calcCTA="Angebot sichern"
                hasGreyBg
            />
            <Cooperation hasMarginTop />
            <HowDoesItWork hasMarginTop hasGreyBg />
            <FantasticNumbersBar hasMarginTop />
            <BreadcrumbList page={"konditionencheck"}></BreadcrumbList>
        </Layout>
    );
};

export default Konditionencheck;

export const query = graphql`
    query ($language: String!) {
        locales: allLocale(
            filter: {
                ns: { in: ["header", "footer", "mortgageCalc", "page.dienstleistungen.konditionencheck"] }
                language: { eq: $language }
            }
        ) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;
